module.exports = __webpack_public_path__ + "static/media/family.f19962e5.jpg";